module.exports = __webpack_public_path__ + "img/logo_b2c.959100b3.png";